var _style, _defs, _path, _path2, _path3, _path4, _path5, _defs2, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConditionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 103 102",
    style: {
      enableBackground: "new 0 0 103 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{clip-path:url(#SVGID_00000044154477334487261860000000059736054464250778_);}\r\n\t.st3{fill:#E86E7B;}\r\n\t.st4{clip-path:url(#SVGID_00000059989787343381319330000002989589004784672703_);}\r\n\t.st5{clip-path:url(#SVGID_00000100381773992479293330000012101603139698493095_);}\r\n\t.st6{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 0,
    width: 102,
    height: 102
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109747859541615421380000005038276544768543922_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000109747859541615421380000005038276544768543922_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M98.2,93.5h-85c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3v-85c0-1.1-0.4-2.2-1.2-3C7,0.4,5.9,0,4.8,0 s-2.2,0.4-3,1.2C0.9,2,0.5,3.1,0.5,4.2v85c0,3.4,1.3,6.6,3.7,9s5.6,3.7,9,3.7h85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3 s-0.4-2.2-1.2-3C100.5,93.9,99.4,93.5,98.2,93.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2S60,49.9,60,51v29.8c0,1.1,0.4,2.2,1.2,3C62,84.6,63.1,85,64.3,85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M30.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3V51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 S26,49.9,26,51v29.8c0,1.1,0.4,2.2,1.2,3C28,84.6,29.1,85,30.2,85z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3c-0.8-0.8-1.9-1.2-3-1.2 s-2.2,0.4-3,1.2c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C79,84.6,80.1,85,81.2,85z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.2,85c1.1,0,2.2-0.4,3-1.2c0.8-0.8,1.2-1.9,1.2-3v-51c0-1.1-0.4-2.2-1.2-3s-1.9-1.2-3-1.2s-2.2,0.4-3,1.2 c-0.8,0.8-1.2,1.9-1.2,3v51c0,1.1,0.4,2.2,1.2,3C45,84.6,46.1,85,47.2,85z"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000160188003591361522770000011711129790659033481_",
    x: 5,
    y: 3.5,
    width: 95,
    height: 95
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073710223316463221700000008029191133659755905_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000160188003591361522770000011711129790659033481_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000073710223316463221700000008029191133659755905_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M40.5,98.5l-19.6,0c-4.2,0-8.2-1.7-11.2-4.6c-3-3-4.6-7-4.6-11.2l0-19.8c0-4.2,1.7-8.2,4.6-11.2 c3-3,7-4.6,11.2-4.6l35.1,0c2.1,0,4.2,0.6,6.1,1.6c1.9,1.1,3.4,2.6,4.5,4.4l12.7-14c1.1-1.2,2.3-2.1,3.7-2.8 c1.4-0.7,2.9-1,4.5-1.1c1.6-0.1,3.1,0.2,4.6,0.7c1.5,0.5,2.8,1.3,4,2.4c2.3,2.1,3.7,5.1,3.9,8.2c0.2,3.1-0.9,6.2-3,8.5L70.1,85.2 c-3.7,4.2-8.3,7.5-13.4,9.8C51.6,97.3,46.1,98.5,40.5,98.5z M20.8,55c-2.1,0-4.1,0.8-5.6,2.3c-1.5,1.5-2.3,3.5-2.3,5.6l0,19.8 c0,2.1,0.8,4.1,2.3,5.6s3.5,2.3,5.6,2.3l19.6,0c4.5,0,8.9-0.9,12.9-2.8c4.1-1.8,7.7-4.5,10.7-7.8l26.9-30.2c0.7-0.8,1.1-1.8,1-2.9 c-0.1-1.1-0.5-2-1.3-2.8c-0.8-0.7-1.8-1.1-2.9-1c-0.5,0-1,0.2-1.5,0.4c-0.5,0.2-0.9,0.5-1.3,0.9L67.6,63.7c-0.8,2.1-2.1,4-3.9,5.4 c-1.8,1.4-3.9,2.4-6.1,2.7l-20.4,2.9c-1,0.2-2.1-0.1-2.9-0.8c-0.8-0.6-1.4-1.6-1.5-2.6c-0.2-1,0.1-2.1,0.8-2.9 c0.6-0.8,1.6-1.4,2.6-1.5L56.5,64c1.1-0.2,2.2-0.7,2.9-1.6c0.7-0.9,1.1-2,1-3.2c-0.1-1.1-0.6-2.2-1.4-3C58.1,55.4,57,55,55.9,55 L20.8,55z M48.5,39.4c-1.8,0-3.5-0.6-4.9-1.7c-6.8-5.4-14.9-13.6-14.9-21.5c-0.1-3.3,1.1-6.4,3.3-8.8c2.2-2.4,5.3-3.8,8.6-3.9 c3,0,5.8,1.2,7.9,3.2c2.1-2.1,5-3.2,7.9-3.2C59.7,3.6,62.8,5,65,7.4c2.2,2.4,3.4,5.5,3.3,8.8c0,7.9-8.1,16.1-14.9,21.5 C52.1,38.8,50.3,39.4,48.5,39.4z M40.6,11.4c-1.2,0.1-2.2,0.7-2.9,1.6c-0.7,0.9-1.1,2-1,3.2c0,3.6,4.6,9.5,11.9,15.4 c7.3-5.9,11.8-11.8,11.8-15.4c0.1-1.2-0.3-2.3-1-3.2c-0.7-0.9-1.8-1.5-2.9-1.6c-1.2,0.1-2.2,0.7-2.9,1.6c-0.7,0.9-1.1,2-1,3.2 c0,1-0.4,2.1-1.2,2.8c-0.7,0.7-1.7,1.2-2.8,1.2s-2.1-0.4-2.8-1.2c-0.7-0.7-1.2-1.7-1.2-2.8c0.1-1.2-0.3-2.3-1-3.2 C42.8,12.1,41.8,11.5,40.6,11.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConditionWhite);
export default __webpack_public_path__ + "static/media/conditionWhite.4bc96a90670e459206eda051e87051d6.svg";
export { ForwardRef as ReactComponent };